"use client";

import { useParams } from "next/navigation";
import { SearchCommand } from "@/components/shared/search-command";
import { getIdFromSlug } from "@/lib/utils";

const SearchBar = () => {
  const params = useParams<{ studySetId: string }>();

  const studySetId = params.studySetId
    ? (getIdFromSlug(params.studySetId) ?? undefined)
    : undefined;

  const context = studySetId ? "study-set" : "global";

  return (
    <div className="w-full">
      <SearchCommand context={context} studySetId={studySetId} />
    </div>
  );
};

export default SearchBar;
